import * as moment from 'moment';

export class DayEvents {

    dayMoment: any;
    dayString: string;
    events: any[];
    dayStamp: string;

    setFromApiModel(apiModel: any): this {
        this.dayString = apiModel.day;
        this.dayMoment = moment(apiModel.day, 'DD.MM.YYYY');

        this.dayStamp = moment(apiModel.day, 'DD.MM.YYYY').startOf('day').format('x');
        this.events = [];
        if (apiModel.events && apiModel.events.length) {
            apiModel.events.forEach((item) => {

                // console.log('!!!!!apiModel',apiModel)
                // console.log('!!!!!apiModel item ',item)

                let timeMoment = moment(apiModel.day, 'DD.MM.YYYY');
                let splitTime = item.time ? item.time.split('.') : ' - - ';
                // if (splitTime) {
                timeMoment.hours(splitTime[0]).minutes(splitTime[1]);
                // }
                this.events.push({
                    description: item.supplier_service_name,
                    serviceName: item.service_name && item.service_name.length ? item.service_name[0].name : item.name,
                    id: item.id,
                    name: item.name,
                    date: item.timeMoment,
                    timeMoment: timeMoment,
                    timeString: item.time ? item.time.split('.').join(':') : ' - - ',
                    serviceId: item.service_name && item.service_name.length ? item.service_name[0].id : null,
                    packageName: item.package_name,
                    comment: item.comment,
                    rooms: item.rooms || [],
                    day: apiModel.day
                });
            });
        }
        return this;

    }
}

